import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dialog } from 'primereact/dialog';
import PrivacyPolicy from './PrivacyPolicy';

class PrivacyPolicyDialog extends Component {

  render() {

    const { open, toggle } = this.props;

    if (!open)
      return null;

    return (
      <Dialog 
        className="PrivacyPolicyDialog"
        visible={open}
        maximizable={true}
        onHide={() => toggle(false)}
        header="Privacy Policy"
      >
        <PrivacyPolicy />
      </Dialog>
    )
  }
}

const mapStateToProps = (state) => {
  return {
  };
}

const mapDispatchToProps = dispatch => {
  return {
  };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(PrivacyPolicyDialog);